import React, { useEffect, useState } from "react";
import clsx from "clsx";
import classes from "./ScrollToTopButton.module.css";

import { ReactComponent as ArrowUpSVG } from "../../../styles/results/icon/arrowUp.svg";

interface Props {
    parentRef?: React.MutableRefObject<any>;
}

const ScrollToTopButton = ({ parentRef }: Props) => {
    const [scroll, setScroll] = useState(0);
    const handleScroll = () => {
        setScroll(parentRef?.current?.scrollTop || window.scrollY);
    };
    const handleUpButton = () => {
        (parentRef?.current || window).scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };
    useEffect(() => {
        (parentRef?.current || window).addEventListener("scroll", handleScroll);
        return () => (parentRef?.current || window).removeEventListener("scroll", handleScroll);
    }, [handleScroll, parentRef]);
    return (
        scroll > document.documentElement.clientHeight && (
            <div onClick={handleUpButton} className={clsx(classes.scrollButtonWrapper)}>
                <ArrowUpSVG />
            </div>
        )
    );
};

export default ScrollToTopButton;
